import { Tab } from '@headlessui/react'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface PageTabProps extends Record<string, unknown> {
  children: React.ReactNode
  className?: string
}

export const PageTab = ({ children, className, ...props }: PageTabProps) => {
  return (
    <Tab
      className={({ selected }) =>
        twMerge(
          selected ? 'border-b-brand-primary text-text-primary' : 'border-b-transparent',
          'main-transition-colors w-fit border-b-2 px-4 py-6 outline-none sm:px-5',
          className,
        )
      }
      {...props}
    >
      <span className="whitespace-nowrap font-inter font-bold sm:text-[17px]">{children}</span>
    </Tab>
  )
}
